import type { Developer } from "@lib/dashboardConfig";
import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { currentDeveloperCacheKey } from "./constants";

/**
 * Get the latest developer information.
 */
export const getDeveloper = reactQueryFetcherAdapter(
  currentDeveloperCacheKey,
  async (signal, companyId: string): Promise<Developer> => {
    return fetch(`/companies/${companyId}/developers/current`, "GET", undefined, { signal });
  }
);
